import React from 'react';
import { getColorFromText } from '../../utils/colors';
import * as S from './styled';
export const LogoImage = ({ logo, logoBackground, placeholder, placeholderVariant = 'mono', size = 'large', aspectRatio = 1.375, }) => {
    const placeholderBackground = placeholderVariant === 'color' && typeof placeholder === 'string'
        ? getColorFromText(placeholder)
        : undefined;
    return (React.createElement(S.Container, { size: size, aspectRatio: aspectRatio, style: { background: logo ? `url(${logoBackground}` : undefined } }, logo ? (React.createElement(S.Image, { src: logo })) : (React.createElement(S.ImagePlaceholder, { size: size, style: {
            background: placeholderBackground,
            color: placeholderBackground ? '#fff' : undefined,
        } }, placeholder))));
};
//# sourceMappingURL=LogoImage.js.map